import * as React from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import * as URL from 'url';
import { getLocalStorage, Analytics, useAnalytics } from '@withjoy/web-core';
import { RouteComponentProps } from 'react-router';
import queryString from 'query-string';

// Recent work that Christian did in app-browser, moving it over

/*
    Q:  Why is this in it's own page ?
    A:  It was set up to be a landing page
        that would introduce people to joy.
        It still could be that.
*/

const localStorage = getLocalStorage();

const getGuidUri = (guidId: string) => {
  const env = window.joyEnv;
  const HOSTNAME = env && env.JOY_CONFIG_GUIDS_HOSTNAME ? env.JOY_CONFIG_GUIDS_HOSTNAME : 'localhost';
  const PORT = env && env.JOY_CONFIG_GUIDS_PORT ? env.JOY_CONFIG_GUIDS_PORT : '3000';
  const PROTOCOL = env && env.JOY_CONFIG_GUIDS_PROTOCOL ? env.JOY_CONFIG_GUIDS_PROTOCOL : 'http';

  return URL.format({
    hostname: HOSTNAME,
    port: PORT,
    protocol: PROTOCOL,
    pathname: `/guids/${guidId}`
  });
};

const placeFormat = (data: PlacesData) => {
  return ['city', 'state', 'country']
    .map(p => data[p])
    .filter(e => !!e)
    .join(', ');
};

export interface Props {
  guid: string;
  history: RouteComponentProps['history'];
}

interface InviteProps extends Props {
  analytics: Analytics;
}

interface PlacesData {
  city: string;
  state: string;
  country: string;
}

interface State {
  ownerFirstname: string;
  done: boolean;
}

class CreateEventInviteLandingComponent extends React.Component<InviteProps, State> {
  state = {
    ownerFirstname: '',
    done: false
  };

  componentDidMount() {
    this.handleInviteLanding();
  }

  handleInviteLanding = () => {
    axios
      .get(getGuidUri(this.props.guid))
      .then(e => e.data.data)
      .then(data => {
        this.setState(data);
        localStorage.setItem('affiliateName', data.affiliateName || null);
        localStorage.setItem('uniqueAffiliateTransactionID', data.uniqueId || null);
        localStorage.setItem(
          'createEventJson',
          JSON.stringify({
            ownerFirstName: data.ownerFirstname,
            ownerLastName: data.ownerLastname,
            fianceeFirstName: '',
            fianceeLastName: '',
            // "savan, gorgia, untied stakes", "phenix, azirona, untied stakes" -- google is very smart...
            place: placeFormat(data)
          })
        );
        return Promise.resolve();
      })
      .then(() => this.setState({ done: true }))
      .catch(e => {
        this.props.analytics.trackError({
          attemptedAction: 'CreateEventInvite',
          errorDescription: `We failed big time at unpacking guid data ! ${e.message}`,
          error: e
        });
        this.props.history.push('/createwedding');
      });
  };

  getQParams() {
    const parsed = queryString.parse(location.search);
    const isEmptyObj = Object.entries(parsed).length === 0;
    if (!isEmptyObj) {
      return queryString.stringify(parsed);
    }
    return '';
  }

  render() {
    return <div>{this.state.done && <Redirect to={'/createWedding?' + this.getQParams()} />}</div>;
  }
}

export const CreateEventInviteLanding: React.SFC<Props> = ({ ...props }) => {
  const analytics = useAnalytics({
    pagePrefix: 'marketing',
    category: 'CreateWedding',
    page: 'weddingspotInvite'
  });

  return <CreateEventInviteLandingComponent analytics={analytics} {...props} />;
};
